export default __webpack_public_path__ + "static/media/mode-dark.eac7ca16.png";